import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { MainButton } from './Button.style'
import _ from 'lodash'
import {TextFieldTypography} from './Typography.js'
import Spinner from '../../common/Spinner'

const useButton = props => {
    // definido como constante porque siempre se espera que sea un objeto
    // solo cambian las propiedades del objeto
    const state = _.cloneDeep(props)
    state.color = 'primary'
    /*
        AVISO:
        Desde UX no permiten solo icono cuando button es tipo link
    */
    // si es link y no tiene label..no mostrar el icono
    if (props.icon && !(state.type === 'link' && !props.label)) {
        // lógica movida al component del botón para cambiar iconos al cambiar props
        state.iconPosition = undefined
        state.icon = undefined
    }

    if (props.type === 'primary') {
        state.variant = 'contained'
    } else if (props.type === 'secondary') {
        state.variant = 'outlined'
    } else {
        // inventado
        state.variant = props.type

        if (state.type === 'tertiary')
            state.variant = `${props.type} ${props.size}`

        // link no tiene size
        if (state.type === 'link') state.size = undefined
    }

    if (!props.label) {
        state.variant = `${state.variant} onlyIcon`
        switch (props.type) {
            case 'primary':
                state.variant = 'primary onlyIcon'
                break
            case 'secondary':
                state.variant = 'secondary onlyIcon'
                break
            default:
                break
        }
    }

    state.disableRipple = true

    return state
}

const ButtonComponent = props => {
    const [icon, setIcon] = useState({startIcon: null, endIcon: null})
    const propsComponent = useButton(props)
    const { label, variant, type, showFloatingDot } = propsComponent

    useEffect(()=>{
        if (!(props?.type === 'link' && !props?.label))
            if (props?.iconPosition === 'start') {
                setIcon({startIcon: props?.isLoading ? <Spinner small colorIcon={props?.type === 'primary' ? 'white' : '#4C1B9B'} /> : props?.icon ?  <props.icon /> : null})
            } else {
                setIcon({endIcon: props?.isLoading ? <Spinner small colorIcon={props?.type === 'primary' ? 'white' : '#4C1B9B'} /> : props?.icon ?  <props.icon /> : null})
            }
    },[props?.icon, props?.isLoading, props?.iconPosition, props?.type, props?.label])

    let widthSize
    if(props?.size === 'small' && props?.icon && props?.type !== 'link' && props.label !== ''){
        widthSize ='90px'
    }
    else if(props?.size === 'small' && !props.icon && props?.type !== 'link'){
        widthSize ='67px'
    }
    else if(props?.size === 'small' && props?.icon && props.label === '' && props?.type !== 'link'){
        widthSize ='35px'
    }
    else if(props?.size === 'medium' && props?.icon && props?.type !== 'link' && props.label !== ''){
        widthSize ='113px'
    }
    else if(props?.size === 'medium' && props?.icon && props?.type !== 'link' && props.label === ''){
        widthSize ='44px'
    }
    else if(props?.size === 'medium' && !props.icon && props?.type !== 'link'){
        widthSize ='83px'
    }
    else if(props.label ==='' && props?.size === 'medium'){
        widthSize ='0px'
    }
    else if(props?.type === 'link' && !props.icon){
        widthSize = '53px'
    }
    else if(props?.type === 'link' && props?.icon){
        widthSize = '79px'
    }
    else if(props?.size=== 'xLarge'){
        widthSize = '100%'
    }

    let paddingSizes
    if(props?.type === 'link'){
        paddingSizes ='0px 0px'
    }
    if(props.type !== 'link' && props?.size === 'small'){
        paddingSizes ='8px 10px'
    }
    else if(props?.size === 'medium' && !props.icon && props.type !== 'link'){
        paddingSizes ='10px 16px'
    }
    else if(props.type !== 'link' && props?.size === 'medium' && props?.icon && props?.label){
        paddingSizes ='10px 16px'
    }
    else if(props.type !== 'link' && props?.size === 'medium' && props.variant === `${props.variant} onlyIcon`){
        paddingSizes ='0px 0px'
    }

    return (
        <MainButton
            className={`${props.theme || ''} ${variant} ${props.classNameProps || ''}`}
            {...{...propsComponent, ...icon}}
            style={{
                height:'100%',
                minWidth: widthSize,
                padding: paddingSizes,
                ...props?.style
            }}>
            {showFloatingDot && <span className="floating-dot"/>}
            {type === 'link'
                ? <TextFieldTypography>{label}</TextFieldTypography>
                : label
            }
        </MainButton>
    )
}

ButtonComponent.propTypes = {
    type: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'link']),
    disabled: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    label: PropTypes.string,
    onClick: PropTypes.func,
    iconPosition: PropTypes.oneOf(['start', 'end']),
    theme: PropTypes.oneOf(['light', 'dark']),
    classNameProps: PropTypes.string,
    showFloatingDot: PropTypes.bool
}

ButtonComponent.defaultProps = {
  label: ""
}
export default ButtonComponent
